import axiosInstance from "../../axios";
import { GET_ASSET_INVENTORY, FETCH_ASSET_TYPES_REQUEST } from "../types/assetInventory";

import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

import { alertSuccess } from "../../utils/feedback";

export const setAssetInventory = (assetInventory) => ({
  type: GET_ASSET_INVENTORY,
  payload: assetInventory,
});

export const fetchAssetTypes = (assetTypes) => ({
  type: FETCH_ASSET_TYPES_REQUEST,
  payload: assetTypes,
});

export const fetchAssetInventory = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await axiosInstance.get(
        `/survey/assets_inventory/${orgaId}`
      );
      console.log(
        "Fetched asset inventory (action):",
        response?.data.assets_discovery
      );
      dispatch(setAssetInventory(response?.data.assets_discovery));
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export function assetTypeList(assetId, orgaId) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Fetching asset types"));
      const res = await axiosInstance.get(
        `/survey/fetch-asset-types/${assetId}/${orgaId}`
      );
      const assetTypes = res.data;
      console.log("Asset Types:", assetTypes);
      dispatch(fetchAssetTypes(assetTypes)); 
      dispatch(requestSucceeded());
      return assetTypes;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      return null;
    }
  };
}

export function updateDiscoveredAssets(orgaId, data) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_discovered_assets"));
      const res = await axiosInstance.post(`/survey/discovered_assets_ops`, {
        orga_id: Number(orgaId),
        ops: data,
      });
      const updatedDiscoveredAssets = res.data;
      dispatch(fetchAssetInventory(orgaId));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return updatedDiscoveredAssets;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}

